import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {
  return (
    <section className="banner">
      <div className='content'>

        <Heading
          title={"Nurturing Faith, Knowledge, and Community"} 
          subTitle={"Welcome to Our Islamic Center"} 
          linear
        />
        <Button 
          link={"Events"} 
          title={"Join Us"} 
        />

      </div>
    </section>
  );
};

export default Banner;